import React from "react";

import { templates } from "@reactivated";

import { TrackOrderSummary } from "../apps/orders/TrackOrderSummary";

export const Template = (
    props: templates.TrackOrderSummaryTemplate,
): React.JSX.Element => {
    return <TrackOrderSummary {...props} />;
};
